export const BASE_ROUTE = "/mi-cuenta";

// Rutas relativas para <Route path=...> (montadas bajo /mi-cuenta/*)
export const ROUTE_PATHS = {
  HOME: "/", // Pestaña Resumen
  SUBSCRIPTION: "suscripcion", // Pestaña Suscripción y adicionales (spec 031)
  VOUCHERS: "comprobantes", // Pestaña Comprobantes (spec 031, ex Facturación)
  PAYMENTS: "pagos", // Pestaña Pagos y recibos (spec 031, ex Historial)
  COMPANY: "empresa", // Pestaña Empresa y seguridad (spec 031, ex Perfil)
  REFERRALS: "referidos", // Pestaña Referidos y créditos (spec 032)
  SEDES_PRO: "sedes-pro", // Pestaña Sedes Pro (spec 033)
  PAYERS: "responsables-de-pago", // Spec 044 Fase B
  MY_BILLING: "mi-facturacion", // Spec 044 Fase B
  AVAILABLE_PLANS: "planes",
  WHATSAPP_CONNECTED: "whatsapp/conectado", // Retorno del alta WhatsApp (spec 050)
  EDIT_PROFILE: "editar-perfil",
  MANAGE_SUBSCRIPTION_DETAILS: "gestionar-suscripcion",
  MANAGE_PAYMENT_METHODS: "actualizar-medio-de-pago",
  ADD_USERS: "agregar-usuarios/:packId",
  // Rutas legacy (bookmarks/código viejo) — redirigen a las nuevas (spec 031)
  LEGACY_BILLING: "facturacion",
  LEGACY_PROFILE: "perfil",
  LEGACY_PAY_HISTORY: "historial-pagos",
};

// Rutas absolutas para navigate() (con prefijo /mi-cuenta)
export const ROUTES = {
  HOME_ROUTE: BASE_ROUTE, // Pestaña Resumen
  SUBSCRIPTION_ROUTE: `${BASE_ROUTE}/suscripcion`,
  VOUCHERS_ROUTE: `${BASE_ROUTE}/comprobantes`,
  PAYMENTS_ROUTE: `${BASE_ROUTE}/pagos`,
  COMPANY_ROUTE: `${BASE_ROUTE}/empresa`,
  REFERRALS_ROUTE: `${BASE_ROUTE}/referidos`,
  SEDES_PRO_ROUTE: `${BASE_ROUTE}/sedes-pro`,
  PAYERS_ROUTE: `${BASE_ROUTE}/responsables-de-pago`,
  MY_BILLING_ROUTE: `${BASE_ROUTE}/mi-facturacion`,
  AVAILABLE_PLANS_ROUTE: `${BASE_ROUTE}/planes`,
  WHATSAPP_CONNECTED_ROUTE: `${BASE_ROUTE}/whatsapp/conectado`,
  EDIT_PROFILE_ROUTE: `${BASE_ROUTE}/editar-perfil`,
  MANAGE_SUBSCRIPTION_DETAILS_ROUTE: `${BASE_ROUTE}/gestionar-suscripcion`,
  MANAGE_PAYMENT_METHODS_ROUTE: `${BASE_ROUTE}/actualizar-medio-de-pago`,
  ADD_USERS_ROUTE: `${BASE_ROUTE}/agregar-usuarios/:packId`,
  // Alias legacy usados por código existente: apuntan al destino NUEVO para
  // que cualquier navigate() viejo caiga directo en la pestaña correcta.
  BILLING_ROUTE: `${BASE_ROUTE}/comprobantes`,
  PROFILE_ROUTE: `${BASE_ROUTE}/empresa`,
  PAY_HISTORY_ROUTE: `${BASE_ROUTE}/pagos`,
};
